module.exports = __webpack_public_path__ + "static/media/Klub Buku Nyala Matahari (logo).e34d24c9.png";